import { createContext } from "react";
import type { ISchemaContext } from "./schema.context.types";
import { WatchtowerVersion } from "@edgetier/watchtower-types";

export const defaultContext: ISchemaContext = {
    isInitialized: false,
    watchtowerVersion: WatchtowerVersion.V1,
    isV1: true,
    isV2: false,
};

export const SchemaContext = createContext<ISchemaContext>(defaultContext);
